import React from 'react';
import { Section } from './ui/Section';
export function MechanismSection() {
  return <Section className="px-6 md:px-12 max-w-5xl mx-auto border-y border-[#d4a853]/10 bg-gradient-to-b from-[#111827]/30 to-transparent" data-id="element-73">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-74">
        <span className="font-mono text-[#d4a853] text-sm tracking-widest uppercase block" data-id="element-75">
          02 // El Mecanismo Único
        </span>

        <h2 className="font-serif text-4xl md:text-5xl font-semibold text-[#f0c674] leading-tight" data-id="element-76">
          La solución se llama <br data-id="element-77" />
          <span className="text-gray-100" data-id="element-78">Micro-Automatización (No-Code)</span>
        </h2>

        <p className="font-sans text-xl text-gray-300 leading-relaxed" data-id="element-79">
          Es el arte de crear un{' '}
          <strong className="text-[#d4a853] font-normal" data-id="element-80">"clon digital"</strong>{' '}
          que se encarga de las uniones de tu negocio: donde el cliente
          contacta, paga y recibe el servicio.
        </p>

        <div className="text-left mt-12 p-8 md:p-12 border border-[#b8860b]/20 bg-[#0a0a0a] relative" data-id="element-81">
          <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-[#d4a853]/50 to-transparent" data-id="element-82" />

          <p className="font-sans text-lg text-gray-400 leading-relaxed mb-6" data-id="element-83">
            No necesitás saber programar. Necesitás arquitectura lógica.
          </p>
          <p className="font-sans text-lg text-gray-400 leading-relaxed" data-id="element-84">
            Con el método{' '}
            <strong className="font-mono text-[#f0c674] font-normal tracking-wide" data-id="element-85">
              P.A.R.A-Auto
            </strong>
            , transformás tu negocio en un sistema que funciona mientras dormís,
            entrenás o estás con tu familia, manteniendo un margen de ganancia
            neto altísimo porque tus costos de software son casi nulos.
          </p>
        </div>
      </div>
    </Section>;
}